import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.195 6.438c.078 0 .149.027.211.082a.255.255 0 0 1 .094.199v4.289c0 .203-.11.375-.328.515v.024L6.07 13.703v.024a.326.326 0 0 1-.14.023.312.312 0 0 1-.211-.082.255.255 0 0 1-.094-.2V9.134c0-.219.102-.39.305-.516L6 8.57l4.031-2.086.047-.023a.26.26 0 0 1 .117-.024zm-.304-1.149c.125.047.187.117.187.211a.252.252 0 0 1-.047.14.265.265 0 0 1-.094.094l-.046.024L5.6 8.03l-.046.024a.672.672 0 0 1-.305.07.672.672 0 0 1-.305-.07l-.047-.024L.61 5.781C.484 5.703.422 5.61.422 5.5c0-.047.015-.086.047-.117a.367.367 0 0 1 .094-.07l.046-.024 4.243-1.922c.171-.078.304-.117.398-.117l.398.117L9.891 5.29zM4.57 8.617c.202.125.304.297.304.516v4.336a.255.255 0 0 1-.094.199.312.312 0 0 1-.21.082.36.36 0 0 1-.141-.047L.328 11.547v-.024C.11 11.383 0 11.211 0 11.008v-4.29c0-.077.031-.144.094-.198a.312.312 0 0 1 .21-.082c.063 0 .102.007.118.023l.047.023L4.477 8.57l.093.047z" id="a" transform="translate(0 -3)" fill={color} fillRule="evenodd" />
    </svg>
)

export default class IconProject extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
